import { useEffect, useState } from "react"
import { useFormikContext } from "formik"
import { FormHelperText, Grid } from "@mui/material"
import { fetchPriceLists, FetchPriceListsResponse, PriceListQuery, PriceListType } from "../../priceList/priceListApi"
import { ApiQueryAutocomplete } from "../../../../../core/api/components/ApiQueryAutocomplete"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { CreateOrEditArticleFormValues } from "../merchantNewsItemType"
import { useMerchant } from "../../../../merchants/merchantHooks"
import { useApiQuery } from "../../../../../core/api/useApiQuery"

const selectPriceLists = (data: FetchPriceListsResponse) => data?.priceLists || []

export function ProductIdSearchField() {
    const { merchantId } = useMerchant()
    const { errors, values, setFieldValue } = useFormikContext<CreateOrEditArticleFormValues>()
    const [priceListItem, setPriceListItem] = useState<PriceListType | null>(null)

    const {
        data = [],
        isLoading,
        isError,
    } = useApiQuery(fetchPriceLists, {
        queryName: PriceListQuery.LIST,
        dependencies: {
            merchantId,
            includeProducts: true,
        },
        select: selectPriceLists,
    })

    useEffect(() => {
        data && setPriceListItem(data.find((option) => option.id === values.product?.id) || null)
    }, [values.product?.id, data])

    const handleChange = (el: PriceListType | null) => {
        el ? setFieldValue("product", { id: el.id }) : setFieldValue("product", undefined)
    }

    return (
        <Grid container gap={1}>
            <LocalizedStrict id="create-or-edit-merchant-article-product-id" attrs={{ label: true }}>
                <ApiQueryAutocomplete
                    isLoading={isLoading}
                    isError={isError}
                    options={data}
                    value={priceListItem}
                    isOptionEqualToValue={(option, value) => option.id === value.id}
                    getOptionLabel={(option) => option.name}
                    onChange={(_, value) => handleChange(value)}
                    label="Product id"
                    fullWidth
                />
            </LocalizedStrict>
            {!!errors.product && <FormHelperText error>{errors.product}</FormHelperText>}
        </Grid>
    )
}
